export default "__VITE_ASSET__Bdmh$0GO__"